// ChatFab.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip'; // Import MUI Tooltip
import './ChatFab.css';

const ChatFab = ({ onClick, isOpen, isFaqHighlighted, pageType }) => {
  const { t } = useTranslation();

  // --- LOGIC TO HIDE ON VERIFICATION PAGE ---
  const location = useLocation();
  // Check if the current path is a verification page or shortlink
  const isVerificationPage = location.pathname.startsWith('/verify') || location.pathname.startsWith('/api/v/');
  // If we are on the verification page, do not render the button
  if (isVerificationPage) {
    return null;
  }

  const label = isOpen ? t('chatFab.closeTooltip') : t('chatFab.openTooltip');
  // Create a key that changes when 'isOpen' changes, to force Tooltip remount
  const tooltipKey = isOpen ? "fab-tooltip-is-open" : "fab-tooltip-is-closed"; // ARIA labels can often stay in English for screen readers

  const fabClasses = [
    'chat-fab',
    isFaqHighlighted ? 'faq-modal-effect' : '',
    pageType === 'info-page' ? 'info-page-fab' : '' // Add our new class
  ].filter(Boolean).join(' '); // .filter(Boolean) removes any empty strings

  return (
    <Tooltip title={label} key={tooltipKey} placement="top">
      {/* The Fab component is now a child of the Tooltip */}
      <Fab
        color="default" // Assuming CSS handles the main styling
        aria-label={label} // Still good for accessibility; MUI Tooltip uses 'title'
        onClick={onClick}
        className={fabClasses}
      >
        {isOpen ? <CloseIcon /> : <ChatIcon />}
      </Fab>
    </Tooltip>
  );
};

export default ChatFab;